import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { AvailableOsUpdatesStoreActions, AvailableOsUpdatesStoreSelectors } from '../available-os-updates';

@Injectable({ providedIn: 'root' })
export class AvailableOsUpdatesResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(AvailableOsUpdatesStoreSelectors.selectAvailableOsUpdatesLoaded).pipe(
      tap((loaded) => {
        if (!loaded) {
          this.store.dispatch(
            AvailableOsUpdatesStoreActions.AvailableOsUpdatesResolverActions.availableOsUpdatesRequested()
          );
        }
      }),
      map(() => true),
      first()
    );
  }
}
